import React, { useState, useRef } from "react";
import DataTable from "react-data-table-component";
import {
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBTabs,
  MDBTabsItem,
  MDBTabsLink,
  MDBTabsContent,
  MDBTabsPane,
} from "mdb-react-ui-kit";

const Proveedores = () => {
  const [activeTab, setActiveTab] = useState("entregas"); // Gestión de pestañas
  const [newProviderModalOpen, setNewProviderModalOpen] = useState(false);
  const [addProviderModalOpen, setAddProviderModalOpen] = useState(false);
  const [providers, setProviders] = useState([]);
  const [deliveries, setDeliveries] = useState([]);
  const [filters, setFilters] = useState({
    provider: "",
    material: "",
    warehouse: "",
    startDate: "",
    endDate: "",
  });
  const [showReceipt, setShowReceipt] = useState(false);
  const receiptRef = useRef();


  const warehouseOptions = ["Bodega A", "Bodega B", "Bodega C"];
  const materialPrices = { Plástico: 5, Vidrio: 3, Papel: 2 };

  const [newDelivery, setNewDelivery] = useState({
    provider: "",
    warehouse: "Bodega A",
    date: new Date().toISOString().split("T")[0],
    materials: [],
  });
  const handlePrintReceipt = () => {
    if (receiptRef.current) {
      const printContent = receiptRef.current.innerHTML;
      const printWindow = window.open("", "_blank");
      printWindow.document.open();
      printWindow.document.write(`
      <html>
          <head>
            <title>Recibo de Entrega</title>
            <style>
  body {
    font-family: 'Roboto', Arial, sans-serif;
    line-height: 1.6;
    margin: 20px;
    background-color: #f4f8fc;
    color: #333;
  }
  h1, h2 {
    text-align: center;
    margin: 10px 0;
    color: #1f4e78;
  }
  h1 {
    font-size: 2rem;
    font-weight: bold;
  }
  h2 {
    font-size: 1.2rem;
    font-weight: 400;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }
  th {
    background-color: #1f4e78;
    color: #fff;
    padding: 12px;
    font-size: 1rem;
    text-transform: uppercase;
  }
  td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: center;
    font-size: 0.95rem;
    color: #555;
  }
  tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  tr:hover {
    background-color: #eaf4fc;
  }
  .footer {
    margin-top: 20px;
    text-align: center;
    font-size: 0.9rem;
    color: #555;
  }
  .footer p {
    margin: 4px 0;
  }
  .logo {
    text-align: center;
    margin-bottom: 20px;
  }
  .logo i {
    font-size: 4rem;
    color: #1f4e78;
  }
</style>

          </head>
          <body>
            ${printContent}
          </body>
        </html>

      `);
      printWindow.document.close();
      printWindow.print();
      printWindow.close();
    }
  };

  const handlePrintReceiptFromRow = (row) => {
    setNewDelivery(row); // Establece la entrega seleccionada
    setTimeout(() => handlePrintReceipt(), 0); // Llama a imprimir después de renderizar
  };
  
  
  const [newProvider, setNewProvider] = useState({ name: "", contact: "" });

  const [newMaterial, setNewMaterial] = useState({ material: "", quantity: 0, unitPrice: 0, totalEarned: 0 });

  const toggleNewProviderModal = () => {
    setNewDelivery({
      provider: "",
      warehouse: "Bodega A",
      date: new Date().toISOString().split("T")[0],
      materials: [],
    });
    setNewMaterial({ material: "", quantity: 0, unitPrice: 0, totalEarned: 0 });
    setNewProviderModalOpen(!newProviderModalOpen);
  };

  const toggleAddProviderModal = () => setAddProviderModalOpen(!addProviderModalOpen);

  const handleAddMaterial = () => {
    if (newMaterial.material && newMaterial.quantity > 0) {
      const updatedMaterials = [...newDelivery.materials, newMaterial];
      setNewDelivery({ ...newDelivery, materials: updatedMaterials });
      setNewMaterial({ material: "", quantity: 0, unitPrice: 0, totalEarned: 0 });
    }
  };

  const calculateGrandTotal = (materials) => {
    return materials.reduce((sum, item) => sum + item.totalEarned, 0);
  };

  const handleSaveDelivery = () => {
    const newDeliveryWithId = {
      ...newDelivery,
      id: deliveries.length + 1,
      totalEarned: calculateGrandTotal(newDelivery.materials),
    };
    setDeliveries([...deliveries, newDeliveryWithId]);
    toggleNewProviderModal();
    setShowReceipt(true);
  };
  

  const handleSaveProvider = () => {
    const newProviderWithId = { ...newProvider, id: providers.length + 1 };
    setProviders([...providers, newProviderWithId]);
    toggleAddProviderModal();
  };

  const deliveriesColumns = [
    { name: "Proveedor", selector: (row) => row.provider, sortable: true, grow: 2 },
    { name: "Bodega", selector: (row) => row.warehouse, sortable: true },
    { name: "Fecha", selector: (row) => row.date, sortable: true },
    { name: "Total Ganado", selector: (row) => `$${row.totalEarned}`, sortable: true },
    {
      name: "Acciones",
      cell: (row) => (
        <button
          className="btn btn-success btn-sm"
          title="Imprimir Recibo"
          onClick={() => handlePrintReceiptFromRow(row)}
        >
          <i className="fas fa-print"></i>
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];
  

  const providersColumns = [
    { name: "Nombre", selector: (row) => row.name, sortable: true, grow: 2 },
    { name: "Contacto", selector: (row) => row.contact, sortable: true },
  ];

  const filteredDeliveries = deliveries.filter((item) => {
    return (
      (!filters.provider || item.provider.toLowerCase().includes(filters.provider.toLowerCase())) &&
      (!filters.warehouse || item.warehouse === filters.warehouse) &&
      (!filters.startDate || new Date(item.date) >= new Date(filters.startDate)) &&
      (!filters.endDate || new Date(item.date) <= new Date(filters.endDate))
    );
  });

  const switchTab = (tab) => {
    if (tab !== activeTab) {
      setActiveTab(tab);
    }
  };

  return (
    <div className="container-fluid p-0">
      <h1 className="h3 mb-3">Gestión de Proveedores</h1>
      <MDBTabs className="mb-3">
        <MDBTabsItem>
          <MDBTabsLink onClick={() => switchTab("entregas")} active={activeTab === "entregas"}>
            Entregas
          </MDBTabsLink>
        </MDBTabsItem>
        <MDBTabsItem>
          <MDBTabsLink onClick={() => switchTab("proveedores")} active={activeTab === "proveedores"}>
            Proveedores
          </MDBTabsLink>
        </MDBTabsItem>
      </MDBTabs>
      <MDBTabsContent>
        {/* Pestaña de Entregas */}
        <MDBTabsPane show={activeTab === "entregas"}>
          <div className="card">
            <div className="card-body">
              <div className="row mb-3">
                <div className="col-md-2">
                  <label className="form-label">Proveedor</label>
                  <input
                    type="text"
                    className="form-control"
                    value={filters.provider}
                    onChange={(e) => setFilters({ ...filters, provider: e.target.value })}
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Bodega</label>
                  <select
                    className="form-control"
                    value={filters.warehouse}
                    onChange={(e) => setFilters({ ...filters, warehouse: e.target.value })}
                  >
                    <option value="">Todas las Bodegas</option>
                    {warehouseOptions.map((warehouse, index) => (
                      <option key={index} value={warehouse}>
                        {warehouse}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-2">
                  <label className="form-label">Fecha Inicio</label>
                  <input
                    type="date"
                    className="form-control"
                    value={filters.startDate}
                    onChange={(e) => setFilters({ ...filters, startDate: e.target.value })}
                  />
                </div>
                <div className="col-md-2">
                  <label className="form-label">Fecha Final</label>
                  <input
                    type="date"
                    className="form-control"
                    value={filters.endDate}
                    onChange={(e) => setFilters({ ...filters, endDate: e.target.value })}
                  />
                </div>
                <div className="col-md-2 text-end">
                  <button className="btn btn-primary mt-4" onClick={toggleNewProviderModal}>
                    <i className="fas fa-truck"></i> Nueva Entrega
                  </button>
                </div>
              </div>

              <DataTable
                columns={deliveriesColumns}
                data={filteredDeliveries}
                pagination
                fixedHeader
                fixedHeaderScrollHeight="450px"
                noDataComponent="No hay entregas disponibles"
              />
            </div>
          </div>
        </MDBTabsPane>

        {/* Pestaña de Proveedores */}
        <MDBTabsPane show={activeTab === "proveedores"}>
          <div className="card">
            <div className="card-body">
              <button className="btn btn-secondary mb-3" onClick={toggleAddProviderModal}>
                <i className="fas fa-user-plus"></i> Nuevo Proveedor
              </button>
              <DataTable
                columns={providersColumns}
                data={providers}
                pagination
                fixedHeader
                fixedHeaderScrollHeight="450px"
                noDataComponent="No hay proveedores registrados"
              />
            </div>
          </div>
        </MDBTabsPane>
      </MDBTabsContent>

      {/* Modales se mantienen iguales */}
      {/* Modal para nueva entrega */}
      <MDBModal show={newProviderModalOpen} setShow={setNewProviderModalOpen} tabIndex="-1">
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Registrar Nueva Entrega</MDBModalTitle>
              <button type="button" className="btn-close" onClick={toggleNewProviderModal}></button>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <div className="mb-3">
                  <label className="form-label">Proveedor</label>
                  <select
                    className="form-control"
                    value={newDelivery.provider}
                    onChange={(e) => setNewDelivery({ ...newDelivery, provider: e.target.value })}
                  >
                    <option value="">Seleccionar Proveedor</option>
                    {providers.map((provider, index) => (
                      <option key={index} value={provider.name}>{provider.name}</option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Bodega</label>
                  <select
                    className="form-control"
                    value={newDelivery.warehouse}
                    onChange={(e) => setNewDelivery({ ...newDelivery, warehouse: e.target.value })}
                  >
                    {warehouseOptions.map((warehouse, index) => (
                      <option key={index} value={warehouse}>{warehouse}</option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Fecha</label>
                  <input
                    type="date"
                    className="form-control"
                    value={newDelivery.date}
                    onChange={(e) => setNewDelivery({ ...newDelivery, date: e.target.value })}
                  />
                </div>

                {/* Tabla de Materiales */}
                <h5>Materiales</h5>
                <div className="mb-3">
                  <label className="form-label">Material</label>
                  <select
                    className="form-control"
                    value={newMaterial.material}
                    onChange={(e) => {
                      const material = e.target.value;
                      setNewMaterial({
                        ...newMaterial,
                        material: material,
                        unitPrice: materialPrices[material] || 0,
                        totalEarned: newMaterial.quantity * (materialPrices[material] || 0),
                      });
                    }}
                  >
                    <option value="">Seleccionar material</option>
                    {Object.keys(materialPrices).map(material => (
                      <option key={material} value={material}>{material}</option>
                    ))}
                  </select>
                </div>
                <div className="mb-3">
                  <label className="form-label">Cantidad (kg)</label>
                  <input
                    type="number"
                    className="form-control"
                    value={newMaterial.quantity}
                    onChange={(e) => {
                      const quantity = parseFloat(e.target.value) || 0;
                      setNewMaterial({
                        ...newMaterial,
                        quantity: quantity,
                        totalEarned: quantity * newMaterial.unitPrice,
                      });
                    }}
                  />
                </div>
                <button type="button" className="btn btn-success mb-3" onClick={handleAddMaterial}>
                  Añadir Material
                </button>

                {/* Tabla de materiales añadidos */}
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Material</th>
                      <th>Cantidad (kg)</th>
                      <th>Precio por Unidad</th>
                      <th>Total Ganado</th>
                    </tr>
                  </thead>
                  <tbody>
                  {newDelivery.materials.map((mat, index) => (
                      <tr key={index}>
                        <td>{mat.material}</td>
                        <td>{mat.quantity}</td>
                        <td>${mat.unitPrice}</td>
                        <td>${mat.totalEarned}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="3" className="text-end"><strong>Total Ganado:</strong></td>
                      <td>${calculateGrandTotal(newDelivery.materials)}</td>
                    </tr>
                  </tfoot>
                </table>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <button type="button" className="btn btn-primary" onClick={handleSaveDelivery}>Guardar Entrega</button>
              <button type="button" className="btn btn-secondary" onClick={toggleNewProviderModal}>Cerrar</button>
             

            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>


{showReceipt && (
  <div ref={receiptRef} style={{ display: "none" }}>
    <h1>Recibo de Entrega</h1>
    <h2>Proveedor: {newDelivery.provider}</h2>
    <h3>Bodega: {newDelivery.warehouse}</h3>
    <h3>Fecha: {newDelivery.date}</h3>
    <table>
      <thead>
        <tr>
          <th>Material</th>
          <th>Cantidad (kg)</th>
          <th>Precio Unitario</th>
          <th>Total Ganado</th>
        </tr>
      </thead>
      <tbody>
        {newDelivery.materials.map((mat, index) => (
          <tr key={index}>
            <td>{mat.material}</td>
            <td>{mat.quantity}</td>
            <td>${mat.unitPrice}</td>
            <td>${mat.totalEarned}</td>
          </tr>
        ))}
      </tbody>
      <tfoot>
        <tr>
          <td colSpan="3" style={{ textAlign: "right" }}>
            <strong>Total Ganado:</strong>
          </td>
          <td>${calculateGrandTotal(newDelivery.materials)}</td>
        </tr>
      </tfoot>
    </table>
  </div>
)}

      {/* Modal para nuevo proveedor */}
      <MDBModal show={addProviderModalOpen} setShow={setAddProviderModalOpen} tabIndex="-1">
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Registrar Nuevo Proveedor</MDBModalTitle>
              <button type="button" className="btn-close" onClick={toggleAddProviderModal}></button>
            </MDBModalHeader>
            <MDBModalBody>
              <form>
                <div className="mb-3">
                  <label className="form-label">Nombre del Proveedor</label>
                  <input
                    type="text"
                    className="form-control"
                    value={newProvider.name}
                    onChange={(e) => setNewProvider({ ...newProvider, name: e.target.value })}
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">Contacto</label>
                  <input
                    type="text"
                    className="form-control"
                    value={newProvider.contact}
                    onChange={(e) => setNewProvider({ ...newProvider, contact: e.target.value })}
                  />
                </div>
              </form>
            </MDBModalBody>
            <MDBModalFooter>
              <button type="button" className="btn btn-primary" onClick={handleSaveProvider}>Guardar Proveedor</button>
              <button type="button" className="btn btn-secondary" onClick={toggleAddProviderModal}>Cerrar</button>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
    
      </MDBModal>
    </div>
  );
};

export default Proveedores;
